import React from 'react'
import { cn } from '@scalis/utils'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/scalis-components/core/dropdown-menu'
import { ButtonIcon } from '../../button-icon'
import { Tooltip } from '../../tooltip'
import { Button, ButtonAlign, ButtonKind, ButtonSize } from '../default'
import { menuItemStyles } from './action-button.styles'
import { ActionButtonProps } from './action-button.types'

export const ActionButton = <T,>({
  className,
  actionsItems,
  value,
  asButtonIcon,
  buttonProps,
}: ActionButtonProps<T>) => {
  const { kind, ...rest } = buttonProps || {}
  const button = asButtonIcon ? (
    <ButtonIcon
      data-testid='action-button'
      icon='fa-solid fa-ellipsis'
      disabled={rest.disabled}
    />
  ) : (
    <Button
      className={cn(
        {
          'w-8 p-1': !buttonProps,
        },
        className,
      )}
      size={ButtonSize.xs}
      kind={(kind as ButtonKind) || ButtonKind.secondary}
      align={ButtonAlign.center}
      {...rest}
      isStandalone={false}
    >
      <i className={cn('fa-solid fa-ellipsis text-neutral-primary')} />
    </Button>
  )
  return (
    <DropdownMenu modal={false}>
      {rest.disabled ? button : <DropdownMenuTrigger asChild>{button}</DropdownMenuTrigger>}

      <DropdownMenuContent
        align='end'
        className='min-w-[192px] rounded-xl bg-white p-2'
      >
        {actionsItems.map((item) => {
          const styles = menuItemStyles({ variant: item.variant })

          return (
            <DropdownMenuItem
              key={item.label}
              onClick={() => item.onClick(value as T)}
            >
              <div className={styles.container()}>
                <div className={styles.icon()}>
                  <i className={item.icon} />
                </div>
                <span className={styles.text()}>{item.label}</span>
                {item.hint && (
                  <Tooltip
                    triggerAsChild
                    content={item.hint}
                    tooltipTrigger={<i className={cn('fa-solid fa-circle-info', styles.tooltipIcon())} />}
                  />
                )}
              </div>
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
